const searchBy = reactive({
  serialNumber: true,
  groupName: true,
  description: true,
  firmwareVersion: true,
});

export const useSearchFilter = () => {
  const search = useRouteQuery<string>('search', '');
  const snSquery = useRouteQuery<string | undefined>('serial_number', '');
  const descriptionQuery = useRouteQuery<string | undefined>('description', '');
  const firmwareVersionQuery = useRouteQuery<string | undefined>(
    'firmware_version',
    '',
  );
  const groupNameQuery = useRouteQuery<string | undefined>('group_name', '');

  watch(
    [search, () => searchBy],
    () => {
      const anyQueryValue =
        snSquery.value ||
        descriptionQuery.value ||
        firmwareVersionQuery.value ||
        groupNameQuery.value;
      if (!search.value && anyQueryValue) {
        search.value = anyQueryValue;
      }

      if (anyQueryValue) {
        searchBy.serialNumber = !snSquery.value;
        searchBy.groupName = !groupNameQuery.value;
        searchBy.description = !descriptionQuery.value;
        searchBy.firmwareVersion = !firmwareVersionQuery.value;
      }
    },
    { immediate: true, once: true },
  );

  watch([search, searchBy], () => {
    snSquery.value =
      search.value && !searchBy.serialNumber ? 'false' : undefined;
    descriptionQuery.value =
      search.value && !searchBy.description ? 'false' : undefined;
    firmwareVersionQuery.value =
      search.value && !searchBy.firmwareVersion ? 'false' : undefined;
    groupNameQuery.value =
      search.value && !searchBy.groupName ? 'false' : undefined;
  });

  return {
    searchBy,
    search,
  };
};
